import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { ApiResponse, PaginatedResponse } from '../models/api.model';
import { ITextBlock } from '../models/text-block.model';

@Injectable({
  providedIn: 'root',
})
export class TextBlocksService {

  private apiUrl = `${environment.apiUrl}/text-block`;

  constructor(private http: HttpClient) { }

  public getAllTextBlocks(
    search?: string,
    sortField: string = 'createdAt',
    sortDirection: string = 'desc',
    page?: number,
    pageSize?: number,
    type?: string
  ): Observable<ApiResponse<PaginatedResponse<ITextBlock>>> {
    let params = new HttpParams()
      .set('sortField', sortField)
      .set('sortDirection', sortDirection);

    if (search && search.trim()) {
      params = params.set('search', search);
    }

    if (type && type.trim()) {
      params = params.set('type', type);
    }

    if (page !== undefined && pageSize !== undefined) {
      params = params.set('page', page.toString())
        .set('pageSize', pageSize.toString());
      return this.http.get<ApiResponse<PaginatedResponse<ITextBlock>>>(`${this.apiUrl}/`, { params });
    }

    return this.http.get<ApiResponse<PaginatedResponse<ITextBlock>>>(this.apiUrl, { params });
  }

  public createTextBlock(textBlock: ITextBlock): Observable<ApiResponse<ITextBlock>> {
    return this.http.post<ApiResponse<ITextBlock>>(this.apiUrl, textBlock);
  }

  public updateTextBlock(id: string, textBlock: ITextBlock): Observable<ApiResponse<ITextBlock>> {
    return this.http.put<ApiResponse<ITextBlock>>(`${this.apiUrl}/${id}`, textBlock);
  }

  public deleteTextBlock(id: string): Observable<ApiResponse<void>> {
    return this.http.delete<ApiResponse<void>>(`${this.apiUrl}/${id}`);
  }
}
